import { View } from 'react-native'
import styled from 'styled-components'
import { Text } from '../../../../elements/typography'

const BadgeCircle = styled(View)`
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${(props) => props.theme.spacing.smedium}px;
  top: ${(props) => props.theme.spacing.medium}px;
  border-radius: ${(props) => props.theme.fontScalingFactor * 55}px;
  background: ${(props) => props.color || '#aa8625'};
  width: ${(props) => props.theme.fontScalingFactor * 55}px;
  height: ${(props) => props.theme.fontScalingFactor * 55}px;
`

const BadgeLabel = styled(Text)`
  color: white;
  text-align: center;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  font-size: ${(props) => props.theme.fontSizes.small}px;
  line-height: ${(props) => props.theme.fontSizes.small}px;
`

export const Badge = ({ children }) => (
  <BadgeCircle>
    <BadgeLabel>{children}</BadgeLabel>
  </BadgeCircle>
)
